import { Controller } from "@hotwired/stimulus"

// Primer Brand's SubdomainNavBar, without React.
//
// Opens the narrow-screen menu and the search dialog, and reveals the skip
// link while it has focus. Both panels are rendered hidden, so the bar reads
// correctly before this runs. Upstream's overflow menu for links that do not
// fit is not ported.
export default class extends Controller {
  static targets = ["skipLink", "inner", "menuButton", "menu", "searchButton", "searchDialog", "searchInput"]

  disconnect() {
    document.body.style.overflow = ""
  }

  showSkipLink() {
    this.skipLinkTarget.classList.remove("visually-hidden")
  }

  hideSkipLink() {
    this.skipLinkTarget.classList.add("visually-hidden")
  }

  toggleMenu() {
    this.setMenuOpen(this.menuButtonTarget.getAttribute("aria-expanded") !== "true")
  }

  setMenuOpen(open) {
    this.menuButtonTarget.setAttribute("aria-expanded", String(open))
    this.menuButtonTarget.classList.toggle("SubdomainNavBar-menu-button--close", open)
    this.menuTarget.classList.toggle("SubdomainNavBar-menu-wrapper--close", !open)
    this.menuTarget.hidden = !open
    document.body.style.overflow = open ? "hidden" : ""
    if (open) this.menuTarget.querySelector("a, button")?.focus()
    else this.menuButtonTarget.focus()
  }

  toggleSearch() {
    this.setSearchOpen(this.searchDialogTarget.hidden)
  }

  closeSearch() {
    this.setSearchOpen(false)
  }

  setSearchOpen(open) {
    if (!this.hasSearchDialogTarget) return
    this.searchDialogTarget.hidden = !open
    this.innerTarget.classList.toggle("SubdomainNavBar-inner-container--search-open", open)
    if (open) this.searchInputTarget.focus()
    else this.searchButtonTarget.focus()
  }

  closeSearchOnOutsideClick(event) {
    if (!this.hasSearchDialogTarget || this.searchDialogTarget.hidden) return
    if (this.searchDialogTarget.contains(event.target) || this.searchButtonTarget.contains(event.target)) return
    this.setSearchOpen(false)
  }

  closeAll() {
    if (this.hasMenuButtonTarget) this.setMenuOpen(false)
    this.setSearchOpen(false)
  }
}
